(() => {
  const SELECTOR = '.cart-page-recommendations .card--related';

  function equalizeCartRecommendationCards() {
    const cards = Array.from(document.querySelectorAll(SELECTOR))
      .filter((card) => card.offsetParent !== null);

    if (!cards.length) return;

    cards.forEach((card) => {
      card.style.minHeight = '';
    });

    let tallest = 0;

    cards.forEach((card) => {
      tallest = Math.max(tallest, card.offsetHeight);
    });

    if (!tallest) return;

    cards.forEach((card) => {
      card.style.minHeight = `${tallest}px`;
    });
  }

  function queueEqualize() {
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(equalizeCartRecommendationCards);
    });
  }

  document.addEventListener('DOMContentLoaded', queueEqualize);
  window.addEventListener('load', queueEqualize);
  window.addEventListener('resize', queueEqualize);
  document.addEventListener('shopify:section:load', queueEqualize);
  document.addEventListener('shopify:section:reorder', queueEqualize);
  document.addEventListener('on:debounced-resize', queueEqualize);

  const observer = new MutationObserver(() => {
    queueEqualize();
  });

  window.addEventListener('load', () => {
    const container = document.querySelector('.cart-page-recommendations');
    if (container) observer.observe(container, { childList: true, subtree: true });
  });
})();
